import React from 'react';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import ToolbarItem from 'components/Toolbar/ToolbarItem';
const downloadIcon = React.createElement(DownloadIcon, null);
// @ts-ignore
const ToolbarDownloadItem = React.forwardRef((props, ref) => {
    return React.createElement(ToolbarItem, Object.assign({ ref: ref, icon: downloadIcon, text: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C" }, props));
});
export default React.memo(ToolbarDownloadItem);
